(function () {
  function waitForElm(selector) {
    return new Promise((resolve) => {
      if (document.querySelectorAll(selector).length != 0) {
        return resolve(document.querySelectorAll(selector));
      }
      const observer = new MutationObserver((mutations) => {
        if (document.querySelectorAll(selector).length != 0) {
          observer.disconnect();
          resolve(document.querySelectorAll(selector));
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  waitForElm(
    ".product-for-points .yotpo-widget-products-redemption .yotpo-login-button .yotpo-action-button-widget button"
  ).then((elements) => {
    elements.forEach(element=>{
      var new_element = element.cloneNode(true);
      element.parentNode.replaceChild(new_element, element);
      new_element.addEventListener("click", function(){
        window.location.href = "#login"
      })
    })
  });

  
  waitForElm(
    ".product-for-points .yotpo-widget-products-redemption .yotpo-is-mobile.yotpo-logged-out .yotpo-redemption-mobile-carousel.yotpo-is-mobile .yotpo-redemption-slider-item"
  ).then((elements) => {
    elements.forEach(element=>{
      var new_element = element.cloneNode(true);
      element.parentNode.replaceChild(new_element, element);
      new_element.addEventListener("click", function(){
        window.location.href = "#login"
      })
    });
  });

  waitForElm(
    ".yotpo-widget-products-redemption .yotpo-redemption-add-to-cart .yotpo-action-button-widget.yotpo-add-to-cart-success-button button, .yotpo-widget-products-redemption .yotpo-mobile-modal .yotpo-redemption-option-view-cart-button-mobile-modal .yotpo-action-button-widget button"
  ).then(async (elements) => {
    elements.forEach(element=>{
      var new_element = element.cloneNode(true);
      element.parentNode.replaceChild(new_element, element);
      new_element.querySelector(".yotpo-action-button-text").classList.add("yotpo-widget-spinner");
      new_element.querySelector(".yotpo-action-button-text").innerHTML = "";
      fetch(window.Shopify.routes.root + 'cart.js')
        .then((res) => res.json())
        .then(async (cart) => {
          // if (typeof openCart == "undefined") await activateCart();
          window.calpak.updateCartItems(cart.items, (c) => {
            window.calpak.updateCart(c);
            new_element.querySelector(".yotpo-action-button-text").classList.remove("yotpo-widget-spinner");
            new_element.querySelector(".yotpo-action-button-text").innerHTML = "View Cart";
            window.calpak.openCart();

            new_element.addEventListener("click", async function(){
              // if (typeof openCart == "undefined") await activateCart();
              window.calpak.openCart();
            })
          });
        });
    });
  });
  waitForElm(
    ".yotpo-widget-products-redemption .yotpo-products-container.yotpo-is-mobile.yotpo-logged-out"
  ).then(async (elements) => {
    elements.forEach(element=>{
      var signBtn = document.createElement("a");
      signBtn.innerHTML="Sign In to Redeem";
      signBtn.href = "#login";
      signBtn.classList.add("yotpo-login-mobile-btn");
      element.appendChild(signBtn)
    });
  });
})();
